import { Typography } from '@mui/material';
import styles from '@src/main/ui/components/common/NotFoundPage/NotFoundPage.module.scss';
import type React from 'react';

export const NotFoundPage: React.FC = () => (
  <div className={styles.notFoundPage}>
    <Typography variant="h3">Not Found! :(</Typography>
    <Typography className={styles.notFoundPage__subtitle}>
      The page you are looking for does not exist.
    </Typography>
  </div>
);
